







































































































































































































































































































import { Component } from 'vue-property-decorator';
import {
  AwardIcon,
  BarChart2Icon,
  BarChartIcon,
  CalendarIcon,
  CheckCircleIcon,
  CheckSquareIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  CircleIcon,
  GridIcon,
  HelpCircleIcon,
  HomeIcon,
  ListIcon,
  SettingsIcon,
  ShieldIcon,
  TargetIcon,
  UserIcon,
  UsersIcon,
  BookIcon,
  CloudDrizzleIcon,
  InboxIcon,
} from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import ToggleMenu from '@/components/common/ToggleMenu.vue';
import { PreferencesAction } from '@/store/PreferencesModule';
import PerfectScrollbar from 'perfect-scrollbar';
import { IUser, UserSpecialType } from 'admiral-core';
import { PermissionMixin } from '@/mixins/PermissionMixin';

@Component({
  components: {
    UserIcon,
    UsersIcon,
    CheckCircleIcon,
    GridIcon,
    CalendarIcon,
    CircleIcon,
    CheckSquareIcon,
    HomeIcon,
    SettingsIcon,
    BarChart2Icon,
    BarChartIcon,
    ToggleMenu,
    ChevronDownIcon,
    ChevronRightIcon,
    ListIcon,
    BookIcon,
    HelpCircleIcon,
    ShieldIcon,
    TargetIcon,
    AwardIcon,
    InboxIcon,
    CloudDrizzleIcon,
  },
})
export default class MainMenu extends mixins(BaseMixin, PermissionMixin) {
  mouseover = 'DASHBOARD';

  submenu = {
    policies: true,
    admin: true,
    goals: true,
    mygoals: true,
    goalsKbv: false,
  };
  isMenuHovered = false;

  async collapseMenu(collapse: boolean) {
    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.collapseMenu}`, collapse);
    this.isMenuHovered = !collapse;
  }

  async mounted() {
    new PerfectScrollbar('#main-menu-content');
    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.expandMobileMenu}`, false);
  }
  get isCollapsed() {
    return this.$store.getters[`PreferencesModule/isMenuCollapsed`];
  }
  get isCollapsedSetting() {
    return this.$store.getters[`PreferencesModule/isMenuCollapsedSetting`];
  }
  onClick(event: MouseEvent) {
    if (
      event.target &&
      (this.$refs.button as HTMLButtonElement | undefined)?.contains(event.target as HTMLElement)
    ) {
      return;
    }
    if (!this.isMobileMenuExpanded || !event.target || !this.$refs.mainmenu) return;
    if (!(this.$refs.mainmenu as HTMLElement).contains(event.target as HTMLElement)) {
      this.close();
    }
  }

  async open() {
    if (this.isMobileMenuExpanded) {
      await this.close();
      return;
    }
    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.expandMobileMenu}`, true);

    document.body.addEventListener('click', this.onClick);
  }
  async close() {
    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.expandMobileMenu}`, false);

    document.body.removeEventListener('click', this.onClick);
  }

  get isMobileMenuExpanded() {
    return this.$store.getters[`PreferencesModule/isMobileMenuExpanded`];
  }

  get hasAgencyKbvUsers() {
    return this.users.some((item: IUser) => item.type === UserSpecialType.Kbv);
  }
}
